import {Popup} from '../Dashboard/charts/PopulationDensityChart/MaptilerWrapper'
import POITooltip from '../Dashboard/charts/PopulationDensityChart/Tooltips/POITooltip'
import HouseholdTooltip from '../Dashboard/charts/PopulationDensityChart/Tooltips/HouseholdTooltip'
import TileLayerTooltip from '../Dashboard/charts/PopulationDensityChart/Tooltips/TileLayerTooltip'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import {useConfig} from '../../store/hooks/config'
import {getRoundedValue} from '../helpers/getRounded'

const CustomPopup = styled(Popup)(({theme}) => ({
  '.maplibregl-popup-content': {
    fontFamily: theme.typography.body2.fontFamily,
    padding: 0,
    background: theme.palette.hpWhite,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.20)',
    borderRadius: 8,
    zIndex: theme.zIndex.tooltip,
    position: 'relative'
  }
}))
export const BaseTooltipComponent = ({hoverInfo, loadingUniqueHouseholds}) => {
  const tooltipId = hoverInfo.id
  const thresholdValue = 9999

  const formatNumber = (value, thresholdValue) => {
    if (value >= thresholdValue) {
      return getRoundedValue(value)
    }
    if (value > 999) {
      return value.toLocaleString('en-US')
    }
    return value
  }

  // Format data numbers
  if (hoverInfo.data) {
    for (const key of Object.keys(hoverInfo.data)) {
      const value = hoverInfo.data[key]
      if (typeof value === 'number') {
        hoverInfo.data[key] = formatNumber(value, thresholdValue)
      }
    }
  }

  // Format personaData numbers
  if (hoverInfo.personaData) {
    for (const key of Object.keys(hoverInfo.personaData)) {
      const value = hoverInfo.personaData[key]
      if (typeof value === 'number') {
        hoverInfo.personaData[key] = formatNumber(value, thresholdValue)
      }
    }
  }
  const {personasConfig} = useConfig()

  const personaLayers =
    Object.keys(personasConfig?.personas || {}).map((key) => `unclustered-${personasConfig?.personas[key]}`) || []

  const renderTooltip = () => {
    if (personaLayers?.includes(tooltipId)) {
      return <HouseholdTooltip data={hoverInfo.data} loadingUniqueHouseholds={loadingUniqueHouseholds} />
    }
    if (tooltipId?.startsWith('counties-fill') || tooltipId?.startsWith('congressionaldistrict-fill')) {
      return <TileLayerTooltip currentView={hoverInfo} data={hoverInfo.data} personaData={hoverInfo.personaData} />
    }
    switch (tooltipId) {
      case 'unclustered-uniqueHousehold':
      case 'unclustered-fullEnrolled':
      case 'unclustered-notEnrolled':
      case 'unclustered-partialEnrolled':
        return <HouseholdTooltip data={hoverInfo.data} loadingUniqueHouseholds={loadingUniqueHouseholds} />
      case 'state-fill':
      case 'counties-fill':
      case 'congressionaldistrict-fill':
      case 'censustract-fill':
      case 'censustract-fill1':
      case 'censustract-fill2':
      case 'censustract-fill3':
      case 'censustract-fill4':
      case 'censustract-filln':
        return <TileLayerTooltip currentView={hoverInfo} data={hoverInfo.data} personaData={hoverInfo.personaData} />
      default:
        return <POITooltip data={hoverInfo.data} />
    }
  }

  return (
    <>
      {hoverInfo.data && (
        <CustomPopup
          longitude={hoverInfo.lng}
          latitude={hoverInfo.lat}
          closeButton={false}
          closeOnClick={false}
          maxWidth={hoverInfo.id === 'unclustered-uniqueHousehold' && 'none'}
        >
          {renderTooltip()}
        </CustomPopup>
      )}
    </>
  )
}

BaseTooltipComponent.propTypes = {
  hoverInfo: PropTypes.object.isRequired,
  loadingUniqueHouseholds: PropTypes.bool
}
